<template>
  <div class="tabbedNavigation">
    <ol>
      <li>
        <router-link to="/" exact-active-class="active">
          <span class="icon icon--overview">{{ $t('Web.Overview.Title') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/history" exact-active-class="active">
          <span class="icon icon--history">{{ $t('Web.History.Title') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/system" exact-active-class="active">
          <span class="icon icon--system">{{ $t('Web.System.Title') }}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/profile" exact-active-class="active">
          <span class="icon icon--profile">{{ $t('Web.Profile.Title') }}</span>
        </router-link>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'TabbedNavigation'
};
</script>

<style lang="scss" scoped>
.tabbedNavigation ol {
  width: $maxWidth;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  background: $white;
  margin: 0 auto;

  li {
    flex: 1 0 25%;
    text-align: center;
    margin: 0;
    padding: 0;

    a {
      display: inline-block;
      @include textTiny;
      width: 100%;
      padding: 6px 0;
      color: $bluey-grey;
      border-bottom: 3px solid white;

      &.active,
      &:hover,
      &:focus {
        border-bottom: 3px solid $greeny-blue;
        color: $greeny-blue;
      }
    }

    .icon {
      display: block;
      width: inherit;
      height: inherit;

      &:before {
        display: block;
        width: 100%;
        height: 20px;
        content: '';
        margin: 0 0 3px 0;
        transition: background 0.25s ease-out;
      }

      &--overview {
        &:before {
          background: url('../../assets/img/ico-tabbar-inactive-overview.svg') no-repeat center
            center;
        }
      }
      .active &--overview {
        &:before {
          background: url('../../assets/img/ico-tabbar-active-overview.svg') no-repeat center center;
        }
      }

      &--history {
        &:before {
          background: url('../../assets/img/ico-tabbar-inactive-history.svg') no-repeat center
            center;
        }
      }
      .active &--history {
        &:before {
          background: url('../../assets/img/ico-tabbar-active-history.svg') no-repeat center center;
        }
      }

      &--system {
        &:before {
          background: url('../../assets/img/ico-tabbar-inactive-system.svg') no-repeat center center;
        }
      }
      .active &--system {
        &:before {
          background: url('../../assets/img/ico-tabbar-active-system.svg') no-repeat center center;
        }
      }

      &--profile {
        &:before {
          background: url('../../assets/img/ico-tabbar-inactive-profile.svg') no-repeat center
            center;
        }
      }
      .active &--profile {
        &:before {
          background: url('../../assets/img/ico-tabbar-active-profile.svg') no-repeat center center;
        }
      }
    }
  }
}
</style>
